<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Payment Methods'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container
*ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (!loaded) {
      <div class="flex-row">
        <div class="flex-row-item">
          <ion-skeleton-text
            animated="true"
            style="width: 100%; height: 50px; border-radius: 6px" />
        </div>
        <div class="flex-row-item">
          <ion-skeleton-text
            animated="true"
            style="width: 100%; height: 50px; border-radius: 6px" />
        </div>
      </div>
      @for (i of [1,2,3,4,5,6,7,8,9,10]; track i) {
        <tidy-card>
          <ion-skeleton-text
            animated="true"
            style="width: 120px; height: 30px; border-radius: 6px" />
          <div style="margin-top: 1rem"></div>
          <ion-skeleton-text
            animated="true"
            style="
              width: 100%;
              height: 40px;
              border-radius: 6px;
              margin-bottom: 2rem;
            " />
          <ion-skeleton-text
            animated="true"
            style="width: 100%; height: 35px; border-radius: 6px" />
          <ion-skeleton-text
            animated="true"
            style="width: 100%; height: 35px; border-radius: 6px" />
          <ion-skeleton-text
            animated="true"
            style="width: 100%; height: 35px; border-radius: 6px" />
        </tidy-card>
      }
    }

    @if (loaded) {
      <form [formGroup]="form" novalidate action="#">
        <div class="flex-row">
          <div class="flex-row-item">
            <tidy-select
              [multiple]="true"
              [label]="'Payment Method'"
              [icon]="'assets/svg/card.svg'"
              [items]="paymentMethodsItems"
              [form]="form.controls.paymentMethod"
              formControlName="paymentMethod"
              class="select-custom-input"
              (optionChange)="changePaymentMethod($event)" />
          </div>
          <div class="flex-row-item">
            <tidy-select
              [multiple]="true"
              [label]="'Status'"
              [icon]="'assets/svg/list.svg'"
              [items]="statusItems"
              [form]="form.controls.status"
              formControlName="status"
              class="select-custom-input"
              (optionChange)="changeStatus($event)" />
          </div>
        </div>
      </form>
      @if (paymentMethods?.length == 0) {
        <tidy-alert>
          <tidy-text [body]="'No payment methods on file.'" />
        </tidy-alert>
      }
      @for (paymentMethod of filteredPaymentMethods; track paymentMethod) {
        <tidy-payment-method-card
          [teamId]="null"
          [paymentMethod]="paymentMethod"
          [paymentMethods]="paymentMethods"
          (action)="handleAction($event)" />
      }
    }

  </tidy-wrapper>
</ng-template>

@if (loaded) {
  <tidy-fab [isRightSidePanelButton]="isRightSideContent" class="bottom-nav-padding">
    <tidy-fab-button class="main-btn"  (click)="goToAddCard()">
      <tidy-image style="margin-left: 10px" src="assets/svg/add-heavy.svg" class="large-body-size" />
      <tidy-text style="margin-right: 10px" largeBody="Add Payment Method" class="white" />
    </tidy-fab-button>
  </tidy-fab>
}

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
